<template>
  <div class="mb-16 font-normal">
    <h2 class="custom-title custom-color-gray font-medium mb-4">
      {{ $t('message.abm.folders.settings.salaryReceipt.question') }}
    </h2>
    <div class="w-full radio-group">
      <zt-radio-button
        :value="'true'"
        v-model="selected"
        name="visible"
        @change="update"
        data-vs-radio-button="salaryReceipt"
      >
        <span class="custom-label">{{
          $t('message.abm.folders.settings.salaryReceipt.option.label')
        }}</span>
      </zt-radio-button>
    </div>
    <div class="w-full">
      <zt-radio-button
        :value="'false'"
        v-model="selected"
        name="visible"
        @change="update"
        data-vs-radio-button="salaryReceipt"
      >
        <span class="custom-label">
          {{
            $t('message.abm.folders.settings.salaryReceipt.option1.label')
          }}</span
        >
      </zt-radio-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubFolderDocumentAi',
  inject: ['stateFolder', 'setSubFolderParams'],
  data() {
    return {
      selected: 'false'
    }
  },
  methods: {
    update() {
      const isSalaryReceipt = /^(true|1)$/i.test(this.selected) && !!this.selected
      this.setSubFolderParams({
        isSalaryReceipt: isSalaryReceipt
      })
    }
  },
  created() {
    this.selected = this.stateFolder.subFolderParams.isSalaryReceipt.toString()
  }
}
</script>

<style scoped lang="scss">
.custom-color-gray {
  color: #575757;
}
.custom-title {
  font-size: 1.5rem;
}
.custom-legend {
  font-size: 1.125rem;
}
.custom-label {
  font-size: 1.25rem;
  line-height: 1;
  color: #000;
}
.radio-legend {
  margin-left: calc(24px + 1rem);
  line-height: 1;
}
</style>
